import React, { Component } from 'react';
import { Container } from 'reactstrap';

class Confirmation extends Component {
  render() {
    return (
      <div className="all-pages">
        <Container>
          <h1>Confirmation</h1>
        </Container>
      </div>
    )
  }
}

export default Confirmation;
